import React from 'react';

// מודל אישור כללי - תחליף ל-window.confirm() הפשוט של הדפדפן, בשימוש בכל
// רחבי הבק אופיס (סגירת מודל עם שינויים שלא נשמרו, שליחת התראה וכו').
// zIndex גבוה מ-overlay של מודלי העריכה (200) - כדי שיוכל להופיע מעליהם
// כשהוא נפתח מתוכם (למשל "לסגור בכל זאת?" מתוך BusinessEditModal)
const ConfirmModal = ({ visible, title = 'אישור פעולה', message, confirmLabel = 'אישור', cancelLabel = 'ביטול', danger, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div style={s.overlay} onClick={onCancel}>
      <div style={s.card} onClick={(e) => e.stopPropagation()}>
        <div style={{ ...s.iconCircle, ...(danger ? s.iconCircleDanger : s.iconCircleInfo) }}>
          {danger ? '⚠️' : '❓'}
        </div>
        <h3 style={s.title}>{title}</h3>
        {message && <p style={s.message}>{message}</p>}
        <div style={s.actions}>
          <button type="button" style={s.cancelBtn} onClick={onCancel}>{cancelLabel}</button>
          <button type="button" style={{ ...s.confirmBtn, ...(danger ? s.confirmBtnDanger : {}) }} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

const s = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 300, padding: 16, direction: 'rtl',
  },
  card: {
    width: '100%', maxWidth: 380,
    background: '#fff', borderRadius: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
    padding: '28px 24px 22px', textAlign: 'center',
  },
  iconCircle: {
    width: 52, height: 52, borderRadius: '50%', margin: '0 auto 14px',
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24,
  },
  iconCircleInfo: { background: '#EEF2FF' },
  iconCircleDanger: { background: '#fff1f1' },
  title: { margin: '0 0 8px', color: '#1a1f36', fontSize: 17, fontWeight: 800 },
  message: { margin: '0 0 22px', color: '#4f566b', fontSize: 13.5, lineHeight: 1.6 },
  actions: { display: 'flex', gap: 10, justifyContent: 'center' },
  cancelBtn: {
    flex: 1, padding: '10px 18px', background: '#f5f7fa', color: '#4f566b',
    border: '1.5px solid #e3e8ee', borderRadius: 10, cursor: 'pointer', fontSize: 13.5, fontWeight: 700,
  },
  confirmBtn: {
    flex: 1, padding: '10px 18px', background: '#1f6feb', color: '#fff',
    border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13.5, fontWeight: 700,
  },
  confirmBtnDanger: { background: '#d93838' },
};

export default ConfirmModal;
